<div class="tab-container" *ngIf="authenticatedTabList?.length" [ngClass]="{'embedded-tabs' : usedInTab}">
    <ul [style.background-color]="tabBgColor" class="nav nav-tabs clear-tab">
        <li *ngFor="let tab of authenticatedTabList$ | async;let i=index;" class="nav-item mr-2" role="presentation"> 
            <a href="function:void(0)" #tabTemplate
            (click)="changeTab(i)"
            [ngClass]="{'nav-link': true, 'active': tab?.name === authenticatedTabList[tabSelected].name}" 
            class="nav-link active" id="{{ tab.name }}-tab" 
            data-bs-toggle="tab" [attr.data-bs-target]="'#' + tab.name" type="button" 
            role="tab" aria-controls="home" aria-selected="true">{{ tab.label }}</a> 
        </li> 
    </ul>
    <div *ngIf="authenticatedTabList[tabSelected].template">
        <ng-container *ngTemplateOutlet="authenticatedTabList[tabSelected].template; 
        context: { $implicit: authenticatedTabList[tabSelected] }">
        </ng-container>
    </div>
</div>
